// Balance the percent above 60 or below 40 to be nearest the center (50).

const percentBalancer = (percent): number => {
  return percent * (percent > 60 ? 0.9 : percent < 40 ? 1.2 : 1)
}

// Constant to place milestone at 33%
const p33 = Math.floor(100 / 3)

// Constant to place milestone at 66%
const p66 = Math.floor((100 / 3) * 2)
export const pointProgress = (cashbackMilestonesPoints, pointsBalance): number => {
  const previousMilestone = cashbackMilestonesPoints.length > 1 ? cashbackMilestonesPoints[0] : 0
  const nextMilestone = cashbackMilestonesPoints[cashbackMilestonesPoints.length - 1]
    ? cashbackMilestonesPoints[cashbackMilestonesPoints.length - 1]
    : 0
  if (pointsBalance === 0) {
    return 0
  }
  if (previousMilestone !== 0) {
    if (previousMilestone === pointsBalance) {
      return p33
    }
    if (nextMilestone === pointsBalance) {
      return p66
    }
    // the unit length from the two milestones
    const milestoneUnits = nextMilestone - (previousMilestone || 0)
    // the unit length from the previous milestone and the current progress
    const progressOnSegmentUnits = pointsBalance - (previousMilestone || 0)
    // the unit length from the beginning and the end of the entire ProgressBar
    const unitTotalProgressBar = milestoneUnits * 3
    // the percentage of the current progress between the two milestones
    const percentProgressBetweenMilestones = (progressOnSegmentUnits * 100) / milestoneUnits
    // the percentage of the current progress between the two milestones, balanced, so as not to make progress too close to the milestones
    const percentProgressBetweenMilestonesBalanced = percentBalancer(
      percentProgressBetweenMilestones,
    )
    // the unit length from the beginning of the progressBar and the current progress
    const unitTotalCurrentProgress =
      (percentProgressBetweenMilestonesBalanced * milestoneUnits) / 100 + milestoneUnits
    // the final percentage of the currentProgress on the entire ProgressBar
    const finalPercentage = (unitTotalCurrentProgress * 100) / unitTotalProgressBar
    if (finalPercentage > 60 && finalPercentage < 66) {
      return 60
    }
    if (finalPercentage > 33 && finalPercentage < 38) {
      return 38
    }
    return finalPercentage
  }
  // the current progress between 0 and the next milestone
  const percent = percentBalancer((pointsBalance * 100) / nextMilestone)
  // the final percentage of the currentProgress on the entire ProgressBar
  return (percent * p66) / 100
}

export const milestonePercentageInterval = (
  pointsBalance,
  bonusVoucherPointsInterval,
): number[] => {
  if (pointsBalance < bonusVoucherPointsInterval) {
    return [p66] // 66% on progress view to place a milestone for points between 0 - first milestone
  }
  return [p33, p66] // 33% & 66% on progress view to place milestones for points more than first milestone
}
